@for (offer of offers(); track trackByOffer($index, offer); let isLast = $last) {
  <div class="result">
    <rt-group
      [class.is-talent-pool]="offer.kind !== 'job'"
      [class.has-no-access]="markOffersWithoutAccess() && !offersWithAccess[offer.id]"
      variant="horizontal"
    >
      @if (offer.status) {
        <rt-offer-status-indicator [offerStatus]="offer" />
      }
      <div class="title-location">
        <rt-heading (click)="goToOffer.emit(offer)" variant="heading light" margin-bottom-small-x>
          {{ offer.title }}
        </rt-heading>
        @if (!isShort() && offer.kind === 'job') {
          @if (offer.locationIds?.length) {
            <rt-assigned-locations-info-container [locationIds]="offer.locationIds!" />
          } @else {
            <span>{{ offer.location }}</span>
          }
        }
      </div>
      @if (!isShort() && editable()) {
        <div layout layout-align-items-center layout-flex-1-1 layout-justify-flex-end>
          <rt-icon-button
            (click)="removeOffer.emit(offer)"
            class="show-on-hover"
            variant="plain"
            iconName="close"
            shape="square"
          />
        </div>
      }
    </rt-group>
    @if (!isLast && !isShort()) {
      <rt-divider />
    }
  </div>
}
